// extracted by mini-css-extract-plugin
export var active = "_i4-2";
export var recordingDot = "_i4-1";
export var recordingIndicator = "_i4-0";